import { module } from 'modujs';
import { Swiper, Pagination } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);

        this.carousel = this.$('carousel')[0]

        if (!this.carousel) {
            this.carousel = this.el
        }
    }

    init() {
        this.length = this.$('item').length

        if (this.length > 1) {
            this.carousel = new Swiper(this.carousel, {
                modules: [
                    Pagination,
                ],
                speed: 300,
                loop: false,
                slidesPerView: 1,
                effect: 'fade',
                allowTouchMove: false,
                preventClicksPropagation: false,
                preventClicks: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                    renderBullet: (index, className) => {
                        return `<span class="${className}">${index + 1}</span>`;
                    }
                }
            })
            this.carousel.on('slideChange', () => {
                this.call('goTo', this.carousel.activeIndex, 'CarouselVisualizerModel')
            })
        }
    }

    destroy() {
        if (this.carousel && this.carousel.destroy) {
            this.carousel.destroy(true, true)
        }
    }
}
